import {
  $SpecialGradeLevel,
  type EnumOption,
  SpecialGradeLevel,
} from '@suntex.fim/enums';

/** Grade options for the team editor forms (team grade is K-8 or Other). */
export const teamGradeOptions: EnumOption<SpecialGradeLevel>[] =
  $SpecialGradeLevel.listOptions([
    SpecialGradeLevel.Kindergarten,
    SpecialGradeLevel.Grade1,
    SpecialGradeLevel.Grade2,
    SpecialGradeLevel.Grade3,
    SpecialGradeLevel.Grade4,
    SpecialGradeLevel.Grade5,
    SpecialGradeLevel.Grade6,
    SpecialGradeLevel.Grade7,
    SpecialGradeLevel.Grade8,
    SpecialGradeLevel.Other,
  ]);
